/*globals document*/

import React from 'react';
import Nav from './Nav';
import Search from './Search';
import Footer from './Footer';
import ApplicationStore from '../stores/ApplicationStore';
import { connectToStores, provideContext } from 'fluxible/addons';
import { handleHistory } from 'fluxible-router';
var cookie = require('react-cookie');
var Modal = require('react-modal');
//var appElement = '';
if (process.env.BROWSER) {
  require('../assets/css/bootstrap.css');
  require('../assets/css/mainlayout.css');
  require('../assets/css/spriteicons.css');
  // require('../assets/font-awesome/css/font-awesome.min.css');
  require('../assets/fonts/proximanovalight.ttf');
  require('../assets/fonts/Lato-Regular.ttf');
  require('../assets/fonts/Lato-Bold.ttf');
  require('../assets/fonts/proximanova-bold-webfont.ttf');
  require('../assets/fonts/proximanova-regular-webfont.ttf');
  require('../assets/fonts/proximanova-semibold-webfont.ttf');

}
// session management
class Application extends React.Component {
  constructor(props, context) {
    super(props, context);
  }
  /*componentDidMount(){
          Modal.injectCSS();
   }*/
  render() {
    var Handler = this.props.currentRoute.get('handler');
    var headerdata = {
      'logged': cookie.load('logged'),
      'username': cookie.load('username')
    };
    return (
      <div ref="mainapp">
        <Nav selected={ this.props.currentPageName } links={ this.props.pages } data={ headerdata } currentNavigate={ this.props.currentNavigate.url } />
        <Handler />
        <Footer />
      </div>
      );
  }
  componentDidUpdate(prevProps, prevState) {
    const newProps = this.props;
    if (newProps.pageTitle === prevProps.pageTitle) {
      return;
    }
    document.title = newProps.pageTitle;
  }
}

Application.contextTypes = {
  getStore: React.PropTypes.func,
  executeAction: React.PropTypes.func
};

Application = provideContext(Application, {
  getFacebookSdk: React.PropTypes.func
});

//Application.context.executeAction(checkUserRegister, response);

export default handleHistory(provideContext(connectToStores(
  Application,
  [ApplicationStore],
  function(stores, props) {
    var appStore = stores.ApplicationStore;
    return {
      currentPageName: appStore.getCurrentPageName(),
      pageTitle: appStore.getPageTitle(),
      pages: appStore.getPages(),
      ApplicationStore: appStore
    };
  }
)));



// WEBPACK FOOTER //
// ./src/components/Application.js